/**
 * @param collection
 * @param value
 * @return {boolean|boolean}
 */
export const includes = function (collection, value) {
    return typeof collection.indexOf === 'function' && collection.indexOf(value) !== -1;
};


/**
 * @param collection
 * @param field
 * @return {*[]|*}
 */
export const pluck = function (collection, field) {
    if (!collection.length) {
        return [];
    }
    return collection.map(function (val) {
        return val[field];
    });
};
